// noinspection ES6CheckImport
import "./index.css";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PaymentMode from "./pages/PaymentMode";
import { DataProvider } from "./contexts/DataProvider";
import { FormDataProvider } from "./contexts/FormData";
import Page404 from "./pages/Page404";

const CACHE_BUSTER_V1 = "2026-05-15-16-45";

function App() {
  console.log("SwinkPay Plugin v0.1.1 - 202605151320");
  return (
    <DataProvider>
      <FormDataProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/plugin" element={<PaymentMode />} />
            <Route path="/plugin/404" element={<Page404 />} />
            <Route path="*" element={<Page404 />} />
          </Routes>
        </BrowserRouter>
      </FormDataProvider>
    </DataProvider>
  );
}

export default App;
